/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, prepareResponseData } from "../../Utilities/utils";

// css
import "./Schools.css";

// api
import schoolApi from "../../api/School";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import SchoolsTable from "../../components/tables/primeTable/schools/SchoolsTable";
import { AuthContext } from "../Root/ProtectedRoute";
import TableLoading from "../../components/skeleton/TableLoading";

const Schools = ({ ...props }) => {
  const { user } = useContext(AuthContext) || {};
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [schoolData, setSchoolData] = useState([]);
  const [schoolToDisableDialog, setSchoolToDisableDialog] = useState(false);
  const [selectedSchoolDetail, setSelectedSchoolDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [search, setSearch] = useState("");
  const [blur, blurChange] = useState("");

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR.current.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (!empty(location) && !empty(location.state)) {
      navigate(null, {
        replace: true,
        state: { schoolAdded: false, schoolUpdated: false },
      });
    }
  }, []);

  useEffect(() => {
    // fetch school data
    getSchools();
  }, [first, rows, blur, user]);

  async function getSchools() {
    try {
      const page = first / rows;
      const response = await schoolApi.getSchools(page, rows, search);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!",
        );
      }
      setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
      setSchoolData(response_data.response);

      // check if a new school was added
      if (location.state !== null) {
        const paramState = !empty(location.state) ? location.state : {};
        const schoolAdded = !empty(paramState.schoolAdded)
          ? paramState.schoolAdded
          : false;
        if (schoolAdded === true || schoolAdded === true) {
          const actionType = schoolAdded ? "added" : "updated";
          responseDialog(
            "success",
            "Success",
            `School ${actionType} successfully!`,
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                schoolAdded: false,
                schoolUpdated: paramState.schoolUpdated || false,
              },
            });
          }
        }
      }
    } catch (error) {
      return responseDialog("error", "Error Alert", "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  }

  //function to show confirm modal
  const showDisableConfirm = (data) => {
    setSelectedSchoolDetail(data);
    setSchoolToDisableDialog(true);
  };

  //function to hide confirm modal
  const hideDisableSchoolDialog = () => {
    setSchoolToDisableDialog(false);
  };

  //function to disable school
  const disableOnclickSelectSchool = async () => {
    try {
      setSchoolToDisableDialog(false);
      if (!isLoading) setIsLoading(true);
      const adminId = !empty(user) && !empty(user._id) ? user._id : "";
      const schoolId =
        !empty(selectedSchoolDetail) && !empty(selectedSchoolDetail._id)
          ? selectedSchoolDetail._id
          : "";
      const active =
        !empty(selectedSchoolDetail) && !empty(selectedSchoolDetail.active)
          ? "Yes"
          : "No";
      const response = await schoolApi.toggleSchool(schoolId, adminId, active);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to ${
                !empty(selectedSchoolDetail) &&
                !empty(selectedSchoolDetail.active) &&
                selectedSchoolDetail.active === false
                  ? "enable"
                  : "disable"
              } school with name, ${
                !empty(selectedSchoolDetail.name)
                  ? `${selectedSchoolDetail.name}`
                  : ""
              }`;
        return responseDialog("error", "Something went wrong1", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `School, ${
          !empty(selectedSchoolDetail.name)
            ? `${selectedSchoolDetail.name}`
            : ""
        }, was ${
          !empty(selectedSchoolDetail) &&
          !empty(selectedSchoolDetail.active) &&
          selectedSchoolDetail.active === true
            ? "disabled"
            : "enabled"
        } successfully!`,
      );
      return getSchools();
    } catch (error) {
      return responseDialog(
        "error",
        "Internal Error!",
        "Something went wrong1",
      );
    } finally {
      setIsLoading(true);
    }
  };

  //go to update school page
  const gotToUpdateSchool = (data) => {
    const schoolId = !empty(data) && !empty(data._id) ? data._id : "";
    if (!empty(schoolId)) {
      return navigate(`/school/${schoolId}/update`);
    }

    return;
  };

  const disableSchoolDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideDisableSchoolDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={disableOnclickSelectSchool}
      />
    </div>
  );

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const onBlurChange = (event) => {
    blurChange(event.target.value);
    setFirst(0);
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add School"
              link="/school/add"
              title="Schools"
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <SchoolsTable
                schools={schoolData}
                confirmDisableSelected={showDisableConfirm}
                goToUpdateSchoolScreen={gotToUpdateSchool}
                onPageChange={onPageChange}
                loading={isLoading}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onSearchChange={onSearchChange}
                onSearchBlur={onBlurChange}
              />
            ) : (
              <TableLoading cols={6} />
            )}
            {/* table end  */}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>

      <Dialog
        visible={schoolToDisableDialog}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={disableSchoolDialogFooter}
        onHide={hideDisableSchoolDialog}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {!empty(selectedSchoolDetail) &&
              !empty(selectedSchoolDetail.active) &&
              selectedSchoolDetail.active ? (
                <span style={{ color: "red" }}>
                  <strong>disable</strong>
                </span>
              ) : (
                <span style={{ color: "green" }}>
                  <strong>enable</strong>
                </span>
              )}{" "}
              the selected school -{" "}
              {selectedSchoolDetail && (
                <b>
                  {!empty(selectedSchoolDetail.name)
                    ? selectedSchoolDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>
    </>
  );
};

export default Schools;
